/* Berkeley Life · The Nitric Oxide Course
   ---------------------------------------------------------------
   ES5 on purpose. This audience skews 45 to 60 and a meaningful share
   of it is on an older iPad or a phone that has not been updated in
   three years. Nothing here needs a transpiler and nothing here uses a
   feature that would silently take the page down on one of them.

   THE NO-JS CONTRACT. Screen s0 is authored .is-on and the sticky bar
   is authored down. With this file deleted the page renders as a cover
   with a dead button, which is a broken page but not a blank one, and
   nothing below ever appears half-built. Never author .is-on onto a
   later screen and never author .is-up into the markup. */

(function () {
  'use strict';

  /* ============ where the result sends her ============
     TWO CONSTANTS, and they are the only lines that change if either
     destination moves.

     THE OFFER IS THIS FOLDER'S OWN PAGE. It used to point at the live
     merged funnel, which meant the primary door on this course handed
     her to a different funnel's two-question quiz. offer.html is a
     copy of that funnel's offer block made into a page of its own, so
     this course now ends where it started, on its own URL, with its
     own cart attribute.

     Relative on purpose. It survives the move onto a Shopify page
     handle without an edit, as long as both files land as siblings.

     The article link stays absolute and stays pointed at the live
     page, because it IS the long version and there is no copy of it
     here. It is the secondary door and it leaves this funnel by
     design, for the reader who wants three thousand words before she
     spends anything.

     The query string this file builds is appended to whichever URL is
     here, so attribution survives either one moving. */
  var OFFER_URL   = '/pages/the-nitric-oxide-starter-kit';
  var ARTICLE_URL = '/pages/where-you-sit-on-the-midlife-energy-curve';

  /* ============ Moreau 2012 ============
     Stage values and their coordinates on the chart in index.html.
     y = 132 - value * 9.6. This is the same drawing as women_lp's
     Figure 3, so a change to the viewBox in either file has to be made
     in both or the two charts stop being one exhibit. */
  var STAGES = [
    { v: '9.9', x: 42,    y: 37,   label: 'premenopausal' },
    { v: '8.2', x: 87.5,  y: 53.3, label: 'early perimenopausal' },
    { v: '6.5', x: 133,   y: 69.6, label: 'late perimenopausal' },
    { v: '5.5', x: 178.5, y: 79.2, label: 'early postmenopausal' },
    { v: '4.7', x: 224,   y: 86.9, label: 'late postmenopausal' }
  ];

  /* The middle three stage labels are set on two lines, so lighting
     "hers" means lighting both halves of it. */
  var STAGE_IDS = [['s_0'], ['s_1', 's_1b'], ['s_2', 's_2b'],
                   ['s_3', 's_3b'], ['s_4', 's_4b']];

  var ORDER = ['s0', 's1', 's2', 's3', 's4', 's5',
               's6', 's7', 's8', 's9', 's10', 's11', 's12'];

  /* The four knowledge questions. Everything about marking, scoring and
     the verdict line on the following screen is driven from here, so
     adding a fifth question is one entry plus its markup. */
  var KNOWLEDGE = ['opts2', 'opts3', 'opts4', 'opts5'];

  var $ = function (id) { return document.getElementById(id); };
  var root = $('bl-q');

  var state = {
    symptoms: [],
    stageIdx: null,
    answers: {},        // opts id -> key she chose
    started: false
  };

  /* ============ reporting ============
     Two destinations because they answer different questions. The
     dataLayer push is the count, riding the GTM already on the page and
     out through the server-side container, which survives ad blockers a
     client-side beacon does not. The Clarity tags are the watch, making
     a session recording filterable, so "show me the women who reached
     question four and left" is one click.

     WHAT IS DELIBERATELY NOT SENT, and this is the same line women_lp
     draws. Not the individual symptoms she ticked. Menopause stage plus
     a symptom list is health data about an identifiable session, and
     the difference between "she is in late peri" and "she reports brain
     fog, cold hands and afternoon crashes" is the difference between a
     segment and a medical note. The stage and a COUNT read the funnel
     perfectly well. If the individual symptoms are ever wanted that is
     a consent decision, not a line to add quietly.

     Both calls are wrapped. An analytics failure must never be able to
     stop her seeing her result. */
  function track(name, data) {
    var payload = { event: name, quiz_id: 'women-no-course' };
    var k;
    for (k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        for (k in data) if (Object.prototype.hasOwnProperty.call(data, k)) {
          window.clarity('set', k, String(data[k]));
        }
      }
    } catch (e) {}
  }

  /* ============ the action bar ============
     It mirrors whichever button the ACTIVE screen is waiting on, and it
     is up only while that button is below the fold.

     WHY IT IS NOT JUST THE RESULT'S ANY MORE. Measured on a real
     320x568 viewport, every screen on this page is taller than the
     viewport and the question screens run 680 to 840px. So on a small
     phone the Continue button is off screen on every question, not
     only on the result, and a quiz whose next step has to be hunted
     for is a quiz she leaves. On 390x844 and 430x932 every question
     screen fits exactly and this bar never appears. It is the answer
     to a short viewport, not a permanent fixture.

     IT TRACKS THE SCREEN RATHER THAN OBSERVING AN ELEMENT. Screens
     hide with visibility, not display, so every screen's button keeps
     a layout box and an IntersectionObserver on any one of them would
     report nonsense about the eleven that are not showing. show() says
     which screen is live and bind() reads the button out of it.

     BELOW THE FOLD, NOT "NOT INTERSECTING". An element below the
     viewport and an element scrolled off the top are the same answer
     to an observer, and here the second case is the one where the bar
     must come DOWN, because she has read past the button and it is
     above her. Reading the rect keeps the two apart. */
  var sticky = $('blSticky');
  var stickyNext = $('blStickyNext');
  var stickyCta = $('blStickyCta');
  var armTimer = null;
  var pending = false;

  /* The in-flow control the bar is currently standing in for, and
     whether it navigates. Null between screens and on anything with no
     action of its own. */
  var mirror = null;
  var mirrorIsLink = false;

  /* #begin is in the selector because the cover has a primary action
     too and it is the one screen where losing the bar matters most.
     She has not committed to anything yet, so a Begin she cannot see
     is the cheapest possible bounce.

     TEACH SCREENS OPT OUT, via data-read, AND THAT IS A DESIGN
     DECISION RATHER THAN AN OVERSIGHT. Those screens are 90 to 380px
     taller than the viewport, so the bar would be up on all of them,
     and a "Next question" pinned to the bottom of a screen whose whole
     job is to teach her something is an invitation to skip the
     teaching. This page sells nothing except what she learns on those
     five screens.

     The cost is that on a short phone she has to scroll to advance
     past a teach screen. That is the correct cost. Scrolling is how
     you read. The screens she is BLOCKED on, meaning the cover, the
     six questions and the result, all keep the bar. */
  function bindMirror() {
    var scr = $(ORDER[at]);
    if (scr && scr.hasAttribute('data-read')) { mirror = null; syncMirror(); return; }
    var btn = scr ? scr.querySelector('[data-next], #begin') : null;
    var link = scr ? scr.querySelector('#rvCta') : null;
    if (btn) { mirror = btn; mirrorIsLink = false; }
    else if (link) { mirror = link; mirrorIsLink = true; }
    else { mirror = null; }
    syncMirror();
  }

  /* Label, href and disabled state copied across every time anything
     could have changed them. A bar that says Continue while the real
     button says "See where I am", or that is live while the real one is
     disabled, is worse than no bar. */
  function syncMirror() {
    if (!stickyNext || !stickyCta) return;
    if (!mirror) { stickyNext.hidden = true; stickyCta.hidden = true; return; }
    if (mirrorIsLink) {
      stickyNext.hidden = true;
      stickyCta.hidden = false;
      stickyCta.textContent = mirror.textContent;
      stickyCta.setAttribute('href', mirror.getAttribute('href') || '#');
    } else {
      stickyCta.hidden = true;
      stickyNext.hidden = false;
      stickyNext.textContent = mirror.textContent;
      stickyNext.disabled = !!mirror.disabled;
    }
  }

  function measure() {
    pending = false;
    if (!sticky) return;
    var up = false;
    if (mirror) {
      /* THE TEST IS THE BOTTOM EDGE, NOT THE TOP, and the difference is
         a button she can see against a button she can press. Measuring
         the top raised the bar only once the control was ENTIRELY
         below the fold, so a Begin showing a four-pixel sliver of its
         own top edge counted as visible and she got no bar and no
         button worth aiming at.

         The bottom edge also handles the far end for free. Once she has
         scrolled past the control, its bottom is negative, which is not
         greater than the viewport height, so the bar retires. One
         comparison, both ends. */
      up = mirror.getBoundingClientRect().bottom > window.innerHeight + 1;
    }
    sticky.className = up ? 'stickybar is-up' : 'stickybar';
    if (root) root.className = up ? 'has-bar' : '';
  }

  /* THE HIDDEN-TAB BRANCH IS A BUG FIX, NOT A MICRO-OPTIMISATION.
     requestAnimationFrame does not fire while the document is hidden,
     so a scroll landing as she switches apps sets `pending` true and
     queues a frame that never arrives. `pending` is still true when
     she comes back, every later scroll returns at the guard, and the
     bar is dead for the rest of the session. Switching apps mid-scroll
     is ordinary phone behaviour.

     Measuring synchronously when hidden is free, because nothing is
     painting and there is no frame to coalesce with. Same fix, same
     comment, in offer.js. */
  function schedule() {
    if (pending) return;
    pending = true;
    if (document.hidden) { measure(); return; }
    requestAnimationFrame(measure);
  }

  /* The listeners are attached once and never removed. The bar is
     wanted on every screen now, so arming and disarming it per screen
     would only be a way to get the two out of step. */
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  // Orientation changes report the OLD viewport for a frame or two on
  // iOS, so this looks again once the new one has settled.
  window.addEventListener('orientationchange', function () {
    setTimeout(measure, 250);
  });

  function stickyDown() {
    clearTimeout(armTimer);
    if (sticky) sticky.className = 'stickybar';
    if (root) root.className = '';
  }

  /* Deferred by one screen transition. A screen fades in over 0.34s
     and she should meet it before a fixed bar slides under it. 400ms
     is that transition plus a frame. If .scr's duration changes,
     change this with it. */
  function stickyArm() {
    clearTimeout(armTimer);
    armTimer = setTimeout(measure, 400);
  }

  /* ============ navigation ============ */
  var at = 0;

  function show(i) {
    if (i < 0 || i >= ORDER.length) return;
    at = i;
    var n;
    for (n = 0; n < ORDER.length; n++) {
      var el = $(ORDER[n]);
      if (!el) continue;
      if (n === i) { el.className = 'scr is-on'; }
      else { el.className = 'scr'; }
    }
    /* 'instant', NOT 'auto', AND THIS ONLY MATTERS ON THE STORE.
       'auto' means "use whatever CSS scroll-behavior says", and the
       Berkeley theme sets scroll-behavior: smooth on <html>. So every
       screen transition animated the scroll to the top over half a
       second while the incoming screen was fading in over 0.34, which
       is not what any of this was designed against and does not
       happen locally, where nothing sets it.

       Safari below 15.4 does not know 'instant' and falls back to
       'auto', which is the behaviour we are trying to avoid, on the
       one browser where it is unavoidable. */
    window.scrollTo({ top: 0, behavior: 'instant' });
    // Down first, then re-measure after the fade. Leaving it up across
    // a transition would show the outgoing screen's label over the
    // incoming screen for a third of a second.
    stickyDown();
    bindMirror();
    stickyArm();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    while (t && t !== document && !t.hasAttribute) t = t.parentNode;
    if (!t || t === document) return;

    if (t.id === 'begin') { track('quiz_open', {}); show(1); return; }

    if (t.hasAttribute('data-next')) {
      var scr = ORDER[at];
      /* Committing an answer is what marks the question. It happens on
         Continue rather than on tap so she can change her mind while
         the question is still on screen, which she cannot once the
         right answer is showing. */
      commit(scr);
      /* Her symptoms have to be on the chart BEFORE she meets it, not
         at the end of the run. The first cut painted these inside
         reveal(), which meant the one screen written to make her feel
         recognised showed her a chart with nothing of hers on it. */
      if (scr === 's1') paintRank();
      if (scr === 's11') { reveal(); return; }
      track('quiz_step', { quiz_step: at + 1, quiz_screen: scr });
      show(at + 1);
      return;
    }

    if (t.hasAttribute('data-back')) { show(at - 1); return; }
  });

  /* The bar's button forwards to the real one rather than duplicating
     what it does, so there is one code path for advancing and the two
     can never disagree. The bar's LINK is a real link with the real
     href and is not intercepted at all. */
  if (stickyNext) {
    stickyNext.addEventListener('click', function () {
      if (mirror && !mirror.disabled) mirror.click();
    });
  }

  /* ============ question 1 · symptoms ============ */
  var opts1 = $('opts1');
  var none = opts1.querySelector('input[value="None of these"]');

  opts1.addEventListener('change', function (e) {
    // "None of these" is exclusive in both directions.
    if (e.target === none && none.checked) {
      var all = opts1.querySelectorAll('input');
      for (var i = 0; i < all.length; i++) if (all[i] !== none) all[i].checked = false;
    } else if (e.target !== none && e.target.checked) {
      none.checked = false;
    }
    readSymptoms();

    /* The denominator, fired on her first answer rather than on load,
       so it counts women who engaged rather than women who arrived.
       Arrivals are already a pageview. Once per session. */
    if (!state.started) { state.started = true; track('quiz_start', {}); }
    syncButtons();
  });

  function readSymptoms() {
    var picked = opts1.querySelectorAll('input:checked');
    state.symptoms = [];
    for (var i = 0; i < picked.length; i++) {
      if (picked[i].value !== 'None of these') state.symptoms.push(picked[i].value);
    }
  }

  /* ============ knowledge questions ============ */
  KNOWLEDGE.forEach(function (id) {
    var box = $(id);
    if (!box) return;
    box.addEventListener('change', function (e) {
      if (box.className.indexOf('is-marked') > -1) return;
      state.answers[id] = e.target.value;
      if (!state.started) { state.started = true; track('quiz_start', {}); }
      syncButtons();
    });
  });

  /* ============ question 6 · stage ============ */
  $('opts6').addEventListener('change', function (e) {
    state.stageIdx = parseInt(e.target.value, 10);
    syncButtons();
  });

  /* Mark a knowledge question and lock it. Called on Continue, and
     idempotent, because Back and forward through the same screen must
     not double-mark or re-fire anything.

     THE RIGHT ANSWER IS ALWAYS MARKED, whether or not she found it. A
     wrong answer she is never shown the correction to is worse than
     asking nothing, and the correction is the entire reason the
     question is here. */
  function commit(scrId) {
    var box = $(scrId).querySelector('.opts[data-answer]');
    if (!box || box.className.indexOf('is-marked') > -1) return;

    var right = box.getAttribute('data-answer');
    var labels = box.querySelectorAll('.opt');
    for (var i = 0; i < labels.length; i++) {
      var key = labels[i].getAttribute('data-key');
      labels[i].className += (key === right) ? ' opt--right' : ' opt--wrong';
      var input = labels[i].querySelector('input');
      if (input) input.disabled = true;
    }
    box.className += ' is-marked';

    var got = state.answers[box.id] === right;
    var slot = document.querySelector('[data-verdict="' + box.id + '"]');
    if (slot) {
      slot.className = 'teach__verdict' + (got ? ' is-right' : '');
      slot.querySelector('span').textContent = got ? 'Correct' : 'Not quite';
    }
    track('quiz_answer', { quiz_q: box.id, quiz_right: got ? 1 : 0 });
  }

  /* Light the rows her own answers land on. Called on leaving question
     one, and again from the result so that going Back to the chart
     after changing an answer does not show a stale one.

     COLD HANDS AND FEET MATCHES NOTHING, and that is correct rather
     than a gap. The Winona release has no row for it, and inventing one
     to make every answer light up would be putting a number on the page
     that the source does not contain. */
  function paintRank() {
    var rows = $('rankList').children;
    for (var r = 0; r < rows.length; r++) {
      var keys = (rows[r].getAttribute('data-sym') || '').split('|');
      var hit = false;
      for (var k = 0; k < keys.length; k++) {
        if (keys[k] && state.symptoms.indexOf(keys[k]) > -1) hit = true;
      }
      rows[r].className = hit ? 'rank__row rank__row--hit' : 'rank__row';
    }
  }

  function score() {
    var n = 0;
    for (var i = 0; i < KNOWLEDGE.length; i++) {
      var box = $(KNOWLEDGE[i]);
      if (box && state.answers[KNOWLEDGE[i]] === box.getAttribute('data-answer')) n++;
    }
    return n;
  }

  /* ============ rehydrate from the DOM ============
     THE DEAD END THIS EXISTS TO PREVENT, and it was a real one on
     women_lp before it was found. Every Continue button ships disabled
     and is only ever enabled from a `change` handler. Browsers restore
     form control state across a back-navigation, and restoring a
     control does NOT fire change. So coming back gives you her answers
     visibly ticked, the screen reset to the first one, and every button
     dead.

     RADIOS ARE THE TRAP, not the checkboxes. Unticking and reticking a
     checkbox fires change and frees the button. Clicking the radio that
     is already selected fires nothing, so on a single-choice question
     the only escape is to pick a DIFFERENT answer, which on the stage
     question means lying about where she is in the transition. She
     either does that or she leaves.

     It rebuilds the STATE and not just the buttons, because `symptoms`
     and `stageIdx` live in closure and a restore knows nothing about
     them. Enabling the buttons alone would walk her to a result built
     from stageIdx === null.

     quiz_start is suppressed rather than fired. These answers already
     fired it in the page life where she typed them, and firing again
     would count one woman twice in the denominator. */
  function syncButtons() {
    readSymptoms();
    var s1 = $('s1').querySelector('[data-next]');
    if (s1) s1.disabled = !opts1.querySelector('input:checked');

    KNOWLEDGE.forEach(function (id) {
      var box = $(id);
      if (!box) return;
      var picked = box.querySelector('input:checked');
      if (picked) state.answers[id] = picked.value;
      var btn = box.parentNode.querySelector('[data-next]');
      if (btn) btn.disabled = !picked;
    });

    var st = $('opts6').querySelector('input:checked');
    if (st) state.stageIdx = parseInt(st.value, 10);
    var s11 = $('s11').querySelector('[data-next]');
    if (s11) s11.disabled = !st;

    if (opts1.querySelector('input:checked')) state.started = true;

    // The bar carries the same disabled state as the button it stands
    // in for, so enabling one always enables the other.
    syncMirror();
  }

  syncButtons();
  bindMirror();
  measure();

  /* pageshow rather than DOMContentLoaded alone. A bfcache restore
     replays no parse and no load event but always fires this, and
     Safari leans on bfcache far harder than Chrome. Run unconditionally
     rather than on event.persisted, because the non-bfcache restore is
     the one that was actually measured. Idempotent by construction. */
  window.addEventListener('pageshow', syncButtons);

  /* ============ the result ============ */
  function reveal() {
    if (state.stageIdx === null) return;
    var s = STAGES[state.stageIdx];

    // Her marker onto the curve. Ring and dot sit on the data point.
    // YOU sits on its own line under the stage labels, at the fixed y
    // the viewBox was extended to make room for.
    $('youRing').setAttribute('cx', s.x); $('youRing').setAttribute('cy', s.y);
    $('youDot').setAttribute('cx', s.x);  $('youDot').setAttribute('cy', s.y);
    $('youLab').setAttribute('x', s.x);
    $('youMark').setAttribute('opacity', '1');

    /* Promote her value and her stage label out of the row of five.
       Every one is set explicitly rather than only hers being added,
       because she can go Back and change her answer and an add-only
       pass would accumulate highlights until the whole chart was lit. */
    /* setAttribute rather than className, because on an SVG element
       className is a read-only SVGAnimatedString and assigning to it
       silently does nothing in some browsers and throws in others. */
    for (var i = 0; i < STAGE_IDS.length; i++) {
      var val = $('v' + i);
      if (val) val.setAttribute('class', 'fmd__val' + (i === state.stageIdx ? ' fmd__val--you' : ''));
      for (var j = 0; j < STAGE_IDS[i].length; j++) {
        var el = $(STAGE_IDS[i][j]);
        if (el) el.setAttribute('class', 'fmd__stage' + (i === state.stageIdx ? ' fmd__stage--you' : ''));
      }
    }

    /* The read-out. Descriptive only. It says what the study measured
       and never what anything will do for her. */
    var read;
    if (state.stageIdx === 0) {
      read = 'Women at this stage measured around <strong>' + s.v +
        '%</strong> in this study, which is the premenopausal average. ' +
        'Blood vessel function declines across the transition that follows, ' +
        'reaching about 4.7% in late postmenopausal women.';
    } else {
      var drop = Math.round((1 - parseFloat(s.v) / 9.9) * 100);
      read = 'Women in the <strong>' + s.label + '</strong> group measured around <strong>' +
        s.v + '%</strong> in this study, against 9.9% before the transition begins. ' +
        'That is roughly <strong>' + drop + '% lower</strong>, in healthy women, ' +
        'independent of the usual risk factors.';
    }

    /* THE DISCLAIMER THE DRAWING MADE NECESSARY, and it is not
       optional. The prose above never claims the number is hers. It
       says "Women in the group measured", names the study, and the
       citation carries n and p. Read alone it is unimpeachable.

       It is not read alone. This screen draws a ring and the word YOU
       onto her point, bolds her stage out of the row of five, and heads
       the panel "Here is where you sit on the curve". That is four
       pieces of personalisation around one population average, and a
       reader takes the picture before she takes the sentence. A
       published average presented as a personal measurement is the
       shape a substantiation challenge takes.

       Both branches get it. A woman told she is at the healthy end has
       the same right not to think it was measured off her.

       DO NOT soften this to "may not reflect your own level", which
       hedges the study rather than describing it. The two facts are
       that it is published and that it is an average. Both are flatly
       true. */
    read += ' This is a published average for your stage. It is not a ' +
      'reading of your own body, which is what the strip is for.';

    $('rvRead').innerHTML = read;

    // Her own answers handed back, without interpreting them.
    if (state.symptoms.length) {
      $('rvSymText').textContent = state.symptoms.length === 1
        ? 'You also told us you have noticed:'
        : 'You also told us you have noticed these ' + state.symptoms.length + ':';
      var ul = $('rvSymList');
      ul.innerHTML = '';
      state.symptoms.forEach(function (sym) {
        var li = document.createElement('li');
        li.textContent = sym;
        ul.appendChild(li);
      });
      $('rvSym').hidden = false;
    } else {
      $('rvSym').hidden = true;
    }

    paintRank();

    var sc = score();
    track('quiz_complete', {
      quiz_stage: state.stageIdx,
      quiz_stage_label: s.label,
      quiz_symptom_count: state.symptoms.length,
      quiz_score: sc
    });

    /* Carry her answers and any inbound ad params through to the offer,
       so Clarity and Shopify can both read which path a purchase came
       from. The score rides along because it is the one number that
       says how much of the education actually landed, and if it
       correlates with conversion that is the argument for building more
       of these.

       THE BAR NEEDS NO SEPARATE STAMP any more, and that is worth
       saying because the version before this one had one and it was a
       standing chance to forget. The bar copies #rvCta's href when it
       binds, and it binds inside show() below, which runs after these
       three lines. One string, set once. */
    var qs = new URLSearchParams(window.location.search);
    qs.set('stage', String(state.stageIdx));
    if (state.symptoms.length) qs.set('sym', String(state.symptoms.length));
    qs.set('score', String(sc));
    qs.set('via', 'course');

    var join = function (url) {
      var hash = '';
      var h = url.indexOf('#');
      if (h > -1) { hash = url.slice(h); url = url.slice(0, h); }
      return url + (url.indexOf('?') > -1 ? '&' : '?') + qs.toString() + hash;
    };

    $('rvCta').setAttribute('href', join(OFFER_URL));
    $('rvAlt').setAttribute('href', join(ARTICLE_URL));

    /* No navigation happened, so nothing downstream has her answers in
       the URL. replaceState puts them there without a load. It cannot
       fix the pageview Shopify recorded before she answered anything.
       If that attribution matters it wants a GTM event, and this is the
       passive half of it. */
    if (window.history && history.replaceState) {
      history.replaceState(null, '', location.pathname + '?' + qs.toString());
    }

    show(ORDER.indexOf('s12'));
  }
})();
